module.exports = __webpack_public_path__ + "img/a285c57.png";